// viewBox trimmed to the drawing's painted bounds, so it fills the box it is given. The
// export padded it — more than most, and off-centre — which is what made it read a size
// smaller than its neighbours in a menu row.
export default function IconEmail({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="1.05 1.23 15.89 15.89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M1.61914 3.9043H16.3804V14.448H1.61914V3.9043Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1421 4.29004L10.4175 8.69311C10.0111 9.00581 9.5126 9.17535 8.99976 9.17535C8.48692 9.17535 7.98846 9.00581 7.58198 8.69311L1.85742 4.29004"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
